import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePlanCatalog } from '@/hooks/usePlanCatalog';
import SignalArt from './SignalArt';

const Hero = () => {
  const { catalog } = usePlanCatalog();
  const launchActive = catalog.launch_active !== false;

  return (
  <section className="relative overflow-hidden bg-foreground text-background">
    <div className="container-wide grid items-center gap-12 py-20 md:py-28 lg:grid-cols-2 lg:gap-16">
      <div className="motion-safe:animate-reveal-up">
        <p className="mb-5 inline-flex items-center rounded-full border border-white/15 px-3 py-1 text-xs uppercase tracking-wide text-background/70">
          A private network for bulk inventory
        </p>

        <h1 className="text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Stop losing deals to a <span className="text-brand">stale</span> menu.
        </h1>

        <p className="mt-6 max-w-xl text-lg text-background/70">
          Upload your inventory sheet or forward the email you already send, and Cannafax builds a
          complete menu: COA, photos, quantity and price for every listing. Share it only with the
          buyers and brokers you choose, and see who opened what.
        </p>

        <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3">
          <Button asChild size="lg" className="bg-brand text-brand-foreground hover:bg-brand/90">
            <Link to="/auth?mode=signup">
              Build your first menu free
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <a
            href="#how"
            className="text-sm font-medium text-background/80 underline-offset-4 hover:text-background hover:underline"
          >
            See how it works
          </a>
        </div>

        <p className="mt-5 text-sm text-background/70">
          Set up in 15 minutes · Nothing public, ever · Buyers never pay
        </p>
        <p className="mt-2 text-sm text-background/50">
          {launchActive
            ? 'Launching soon · Every plan is free until then · Buyers are free, forever'
            : 'Buyers are free, forever. No card, no trial clock.'}
        </p>
      </div>

      <SignalArt className="motion-safe:animate-reveal-up lg:pl-6" />
    </div>
  </section>
  );
};

export default Hero;